module.exports = __webpack_public_path__ + "img/imagen-izquierda.fd63c7d3.png";